"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _GET_OFFER = _interopRequireDefault(require("./utils/graphql/GET_OFFER"));

var _ADD_SERVICE_LOG = _interopRequireDefault(require("./utils/graphql/ADD_SERVICE_LOG"));

var _reactHooks = require("@apollo/react-hooks");

var _LoadingSearch = _interopRequireDefault(require("./LoadingSearch"));

var _EmailCapture = _interopRequireDefault(require("./EmailCapture"));

var _Lincx = _interopRequireDefault(require("./Lincx"));

var _OfferPage = _interopRequireDefault(require("./OfferPage"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UserEnd = function UserEnd(_ref) {
  var theme = _ref.theme,
      tracking = _ref.tracking;

  var _useState = (0, _react.useState)((0, _bluekeelControllers.checkCookie)('em_sub')),
      _useState2 = _slicedToArray(_useState, 1),
      duplicateUser = _useState2[0];

  var _useState3 = (0, _react.useState)('email'),
      _useState4 = _slicedToArray(_useState3, 2),
      pageView = _useState4[0],
      setPageView = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      animationPlayed = _useState6[0],
      setAnimationPlayed = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isSubmission = _useState8[0],
      setAsSubmission = _useState8[1];

  var _useState9 = (0, _react.useState)(tracking['isRedirection']),
      _useState10 = _slicedToArray(_useState9, 2),
      isRedirect = _useState10[0],
      setAsRedirection = _useState10[1];

  var _useState11 = (0, _react.useState)(tracking['email']),
      _useState12 = _slicedToArray(_useState11, 2),
      emailValue = _useState12[0],
      setEmailValue = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      offerFound = _useState14[0],
      setStateOffer = _useState14[1];

  var hasFired = (0, _react.useRef)(false);

  var _useMutation = (0, _reactHooks.useMutation)(_ADD_SERVICE_LOG.default, {
    onCompleted: function onCompleted(data) {
      hasFired.current = true;
      console.log(data.addServiceLog.message);
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addTagToServiceLog = _useMutation2[0];

  var handleOfferFound = function handleOfferFound(data, error) {
    if (data && !offerFound) {
      var offer = data.fetchOfferFromFlow.body;
      console.log('offer1:', offer);

      if (!hasFired.current) {
        addTagToServiceLog({
          variables: {
            service: {
              program_id: offer['program_id'],
              group_id: offer['group_id'],
              offer_id: offer['id'],
              clickId: Number(tracking['hsid'])
            }
          }
        });
      }

      ;
      setStateOffer(offer);

      if (duplicateUser && !isSubmission) {
        console.log('Duplicate User...sending to offer'); // Because there has not been a click event yet...

        setAsRedirection(true);
        setPageView('offer');
      }

      ;

      if (tracking['email'] === 'omit') {
        console.log('Omitting email optin...sending to offer page');
        setEmailValue('');
        setPageView('offer');
      }

      ;

      if (offer['offer_page'] === 'selection' && emailValue !== '') {
        console.log('Email opt in handled by selection page...');
        setPageView('offer');
      }

      ;
    }

    ;

    if (error) {
      console.error('ERROR fetching Offer:', error);
    }

    ;
  };

  var _useQuery = (0, _reactHooks.useQuery)(_GET_OFFER.default, {
    variables: {
      queryData: {
        auth_group: tracking['auth_group'],
        pid: Number(tracking['pid']),
        vertical: tracking['vertical'],
        loan_type: tracking['loan_type'],
        debt_type: tracking['debt_type'],
        debt_amount: tracking['debt_amount'],
        debt_optin: tracking['debt_optin'],
        checking_optin: tracking['checking_optin']
      },
      user: {
        location: tracking['location'],
        clickId: Number(tracking['hsid'])
      }
    },
    skip: offerFound || tracking['vertical'] === 'lincx',
    onCompleted: handleOfferFound
  }),
      loading = _useQuery.loading;

  if (loading || !animationPlayed) {
    return /*#__PURE__*/_react.default.createElement(_LoadingSearch.default, {
      onComplete: function onComplete() {
        return setAnimationPlayed(true);
      }
    });
  }

  ;

  if (tracking.vertical === 'lincx') {
    return /*#__PURE__*/_react.default.createElement(_Lincx.default, {
      tracking: tracking,
      email: emailValue
    });
  }

  ;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pageView === 'email' && /*#__PURE__*/_react.default.createElement(_EmailCapture.default, {
    email: emailValue,
    setEmail: setEmailValue,
    setPage: setPageView,
    setSubmission: setAsSubmission,
    theme: theme
  }), pageView === 'offer' && /*#__PURE__*/_react.default.createElement(_OfferPage.default, {
    email: emailValue,
    offer: offerFound,
    tracking: tracking,
    isSubmission: isSubmission,
    isRedirect: isRedirect,
    theme: theme
  }));
};

var _default = UserEnd;
exports.default = _default;

//# sourceMappingURL=UserEnd.jsx.map